var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLines = function SvgLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BFE3FF",
    strokeLinecap: "round",
    strokeOpacity: 0.72,
    strokeWidth: 3,
    d: "M2 1.5h36"
  })));
};
export default SvgLines;